import { defineMessages } from 'react-intl';

export default defineMessages({
  clearFiltersButton: {
    id: 'designOptionFilters.clearFiltersButton',
    description: 'Clear filters button',
    defaultMessage: 'Clear And Continue',
  },
  cancelButton: {
    id: 'designOptionFilters.cancelButton',
    description: 'Cancel clear filters button',
    defaultMessage: 'Cancel',
  },
  warningTitle: {
    id: 'designOptionFilters.clearGlobalFiltersTitle',
    description: 'Clear filters warning title',
    defaultMessage: 'Clear all global filters?',
  },
  warningMessage: {
    id: 'designOptionFilters.clearGlobalFiltersMessage',
    description: 'Clear filters warning message',
    defaultMessage:
      'Searching within a group will result in clearing all filters applied to the global search. Are you sure you want to continue?',
  },
});
